import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Introveteran() {
  return (
    <section className="introveteran text_white">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Introduction – The Veteran App</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introveteran;
